/* Product sliders: one controller per section, also after theme-editor reloads. */
(() => {
  if (window.krCollectionSlidersLoaded) return;
  window.krCollectionSlidersLoaded = true;
  const controllers = new Map();

  function init(root) {
    root.querySelectorAll('.featured-collection-section .product-grid.enable-mobile-slider').forEach(slider => {
      if (controllers.has(slider)) return;
      const track = slider.querySelector('.slider-container');
      const cards = [...slider.querySelectorAll('.product-card')];
      if (!track || !cards.length) return;
      const currentLabel = slider.querySelector('.slider-counter--current');
      const totalLabel = slider.querySelector('.slider-counter--total');
      const events = new AbortController();
      const mobile = window.matchMedia('(max-width: 768px)');
      let current = 0;
      let frame = 0;
      if (totalLabel) totalLabel.textContent = cards.length;

      function update() {
        frame = 0;
        if (!mobile.matches) return;
        const trackRect = track.getBoundingClientRect();
        const center = trackRect.left + track.clientWidth / 2;
        let distance = Infinity;
        cards.forEach((card, index) => {
          const rect = card.getBoundingClientRect();
          const nextDistance = Math.abs(rect.left + rect.width / 2 - center);
          if (nextDistance < distance) { distance = nextDistance; current = index; }
        });
        if (currentLabel) currentLabel.textContent = current + 1;
      }
      function scheduleUpdate() {
        if (!frame) frame = requestAnimationFrame(update);
      }
      function move(step) {
        if (!mobile.matches) return;
        current = (current + step + cards.length) % cards.length;
        const left = cards[current].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
        track.scrollTo({ left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        if (currentLabel) currentLabel.textContent = current + 1;
      }
      slider.querySelector('.slider-button--prev')?.addEventListener('click', () => move(-1), {signal: events.signal});
      slider.querySelector('.slider-button--next')?.addEventListener('click', () => move(1), {signal: events.signal});
      track.addEventListener('scroll', scheduleUpdate, {passive: true, signal: events.signal});
      window.addEventListener('resize', scheduleUpdate, {signal: events.signal});
      controllers.set(slider, () => { events.abort(); cancelAnimationFrame(frame); });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once: true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((destroy, slider) => {
      if (event.target.contains(slider)) { destroy(); controllers.delete(slider); }
    });
  });
})();
